import React from "react";
import cn from "classnames";
import ArrowRightIcon from "../../../shared/icons/ArrowRightIcon";
import style from "../common.module.scss";

const OrdersSectionItemInfoColumn = ({
  title = "",
  children,
  withArrowRight = false,
  isTextBig = false,
  textColor = "",
  isFullWidth = false,
  contentGridColumn = 0,
  contentFlexColumn = 0,
  contentGap = 8,
  onClick,
}) => {
  return (
    <>
      <div
        className={cn(style.infoColumn__wrapper, {
          [style.infoColumn__wrapper_big]: isTextBig,
          [style.display_grid]: contentGridColumn,
          [style.display_flex]: contentFlexColumn,
        })}
        style={{
          gridTemplateColumns: contentGridColumn ? `${contentGridColumn}` : "",
          flex: contentFlexColumn ? `${contentFlexColumn}` : "",
          gap: contentGap ? `${contentGap}px` : "",
          color: textColor,
        }}
        onClick={(e) => {
          if (onClick) {
            onClick(e);
          }
        }}
      >
        {children}
        {withArrowRight && (
          <ArrowRightIcon
            className={cn(style.arrowRight, { [style.arrowRight_withColumn]: contentGridColumn })}
          />
        )}
      </div>
    </>
  );
};

export default OrdersSectionItemInfoColumn;
